angular.module('mtic.components.notifications')
.directive('userMessage', function ($log, EventManager, $timeout, language, userAccount, api, notificationService) {
  return {
    templateUrl: 'template.html',
    scope: {
        message: "=",
        fromUser: "="
    },
    link: function (scope) {
      var eventManager = new EventManager('userMessage');
      scope.dismiss = function(){
          notificationService.dismissNotification();
      }
    }
  }
})
